import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Wrapper = styled(View, theme => {
  return {
    base: {
      flex: 1,
      minWidth: theme.sizingTiny,
      gap: theme.spacingInlineTwopulse,
      padding: theme.paddingInsetNone,
      justifyContent: 'center',
      backgroundColor: theme.colorActionFillNeutralTertiaryEnabled,
    },
    variants: {
      type: {
        title: {
          flexShrink: 1,
          width: '100%',
        },
        interactive: {},
      },
    },
  }
})
